<template>
  <svg width="160" height="12">
    <pattern :id="`hatch${randomNumber}`" patternUnits="userSpaceOnUse" width="4" height="4">
      <path
        d="M-1,1 l2,-2
           M0,4 l4,-4
           M3,5 l2,-2"
        :style="`stroke:${color}; stroke-width:1`"
      />
    </pattern>
    <rect
      v-for="answer in answers"
      :key="answer.value"
      :stroke="value[0] == answer.value ? color : colors[0]"
      :fill="
        value[0] == answer.value ? (hasFill ? color : `url(#hatch${randomNumber})`) : colors[0]
      "
      stroke-width="1"
      width="25"
      height="7"
      ry="4"
      rx="4"
      :x="(answer.value - 1) * 32 + 2"
      y="3"
    ></rect>
  </svg>
</template>

<script>
import authorAnswerColors from './mixins/authorAnswerColors';
export default {
  props: ['value', 'show'],
  mixins: [authorAnswerColors],
  computed: {
    randomNumber() {
      return new Date().toISOString();
    },
    color() {
      return this.value[0] ? this.colors[this.value[0]] : this.colors[0];
    },
    hasFill() {
      return !this.value[0] || this.value[1] == 2;
    }
  }
};
</script>
